import { SPONSORED_AIRLINE_V2_LOADED } from '../../../../actions/sponsoredAirlineV2';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { SponsoredAirlineV2 } from '@web-platform/shared-universal-types/src/redux/state/entities/sponsoredAirlineV2';

export const sponsoredAirlineV2Reducer = (
  state: SponsoredAirlineV2 | null = null,
  action: Action,
): SponsoredAirlineV2 | null => {
  switch (action.type) {
    case SPONSORED_AIRLINE_V2_LOADED:
      return action.payload.sponsoredAirlineV2;
    default:
      return state;
  }
};
